import React from 'react';
import { Radio } from 'react-bootstrap';
import styles from '../../statics/styles';

export default class RadioButtonMaker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSize: ''
    };
  }


  handleRadioChange = (value) => {
    this.setState({ selectedSize: value });
  };

  buttonClicked = () => {
    const { selectedSize } = this.state;
    if (selectedSize) {
      this.props.onCheckBoxSelect(selectedSize);
      this.props.whenClicked(this.state);
    }
  };

  render() {
    const submitButton = this.makeSubmitButton(this.props.submitButton);

    const items = this.props.sizeArray.map((size, i) => {
      return (
        <form className='button-container custom_checkbox' style={this.props.divStyle} key={i}>
          <Radio
            name="sizeRadio"
            value={size}
            checked={this.state.selectedSize === size}
            onChange={() => this.handleRadioChange(size)}
            style={{ marginRight: '10px', fontWeight: '600' }}
          >
            <span />
          </Radio>
          <p style={{ marginRight: '40px' }}>{size}</p>
        </form>
      );
    });

    return (
      <div className="checkbox_container">
        <form className='button-container' style={{
          display: 'flex',
          justifyContent: 'center',
          paddingTop: 10,
          flexWrap: 'wrap'
        }}>
          {items}
        </form>
        {submitButton}
      </div>
    );
  }

  makeSubmitButton(button) {
    return (
      <div>
        <div style={this.props.btnStyle}>
          <button
            style={styles.btn__main1}
            className={button.classname}
            onClick={this.buttonClicked}>{button.name}</button>
        </div>
      </div>
    );
  }
}

RadioButtonMaker.propTypes = {
  btnStyle: React.PropTypes.object.isRequired,
  divStyle: React.PropTypes.object.isRequired,
  onCheckBoxSelect: React.PropTypes.func.isRequired,
  sizeArray: React.PropTypes.array.isRequired,
  submitButton: React.PropTypes.object.isRequired,
  whenClicked: React.PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/subcomponents/RadioBoxMaker.jsx